import { render, staticRenderFns } from "./partner_item_administrators.vue?vue&type=template&id=03ac4947"
import script from "./partner_item_administrators.vue?vue&type=script&lang=js"
export * from "./partner_item_administrators.vue?vue&type=script&lang=js"
import style0 from "./partner_item_administrators.vue?vue&type=style&index=0&id=03ac4947&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports